import { useMemo } from 'react';

import { reactSelectComponents } from '../reactSelectComponents';

import styles from '../Select.module.scss';

export const Control = (props: any) => {
  const { selectProps }: { [key: string]: any } = props;
  const { label, validation } = selectProps;
  const Root = useMemo(() => (label ? 'label' : 'div'), [label]);

  return (
    <Root>
      {!!label && (
        <div className={styles.label}>
          {label}
          {validation.required ? ' *' : ''}
        </div>
      )}
      <reactSelectComponents.Control {...props} />
    </Root>
  );
};
